<div>
    <div class="signature-wrap">
        <div class="signature-wrapper">
            <label for="signature-pad"><abbr title="required">* </abbr>Please enter your digital signature</label>
            <kendo-signature id="signature-pad" class="signature" [readonly]="readOnly" #signature (keyup.enter)="keyDown()"
                [(value)]="value" [color]="color" [strokeWidth]="strokeWidth" [smooth]="true" [maximizable]="false"
                [hideLine]="true" (focusin)="focus()" (focusout)="blur()"
                [attr.aria-label]="'* Required field. Signature pad press enter or use focus mode to sign with a mark, otherwise a mouse is required'"></kendo-signature>

            <button class="bofa--button primary outlined bottom-space" type="button" [disabled]="readOnly"
                (click)="onClear()">Clear
                signature</button>
        </div>
    </div>
</div>